<nav class="flex gap10">
    <smart-router-link link="/midrash" [isRouterLink]="isAngularApp">
        <label>
            <span class="mat-icon" aria-hidden="true">menu_book</span>
            <span i18n="@@beitHaMidrash" [ngClass]="{ active: activeLocation() === SiteLocations.Midrash }">בית מדרש </span>
        </label>
    </smart-router-link>
    <smart-router-link link="/ask" [isRouterLink]="isAngularApp">
        <label>
            <span class="mat-icon" aria-hidden="true">contact_support</span>
            <span i18n="@@askTheRabbi" [ngClass]="{ active: activeLocation() === SiteLocations.Ask }">שאל את הרב </span>
        </label>
    </smart-router-link>
    <a [ngClass]="{ active: activeLocation() === SiteLocations.Calendar }" href="/calendar">
        <label>
            <span class="mat-icon" aria-hidden="true">calendar_month</span>
            <span i18n="@@calendar"> לוח שנה </span>
        </label>
    </a>
    @if (!android) {
        <a id="wikiMenuLink" [ngClass]="{ active: activeLocation() === SiteLocations.Wiki }" href="/wiki">
            <label>
                <span class="mat-icon" aria-hidden="true">language</span>
                <span i18n="@@wiki"> ויקישיבה </span>
            </label>
        </a>
    }
    @if (android) {
        <a id="androidAppSettings" onclick="Android.openSettings()">
            <label>
                <span class="mat-icon" aria-hidden="true">settings</span>
                <span i18n="@@androidSetting"> הגדרות אפליקציה </span>
            </label>
        </a>
    }
</nav>
